import { render, staticRenderFns } from "./RoomCallSpeechText.vue?vue&type=template&id=8d4db896&scoped=true&"
import script from "./RoomCallSpeechText.vue?vue&type=script&lang=js&"
export * from "./RoomCallSpeechText.vue?vue&type=script&lang=js&"
import style0 from "./RoomCallSpeechText.vue?vue&type=style&index=0&id=8d4db896&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4db896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d4db896')) {
      api.createRecord('8d4db896', component.options)
    } else {
      api.reload('8d4db896', component.options)
    }
    module.hot.accept("./RoomCallSpeechText.vue?vue&type=template&id=8d4db896&scoped=true&", function () {
      api.rerender('8d4db896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Call/RoomCallSpeechText.vue"
export default component.exports